export default "__VITE_ASSET__qLwYqmzo__"